import xhr from '../utils/xhr';

let api = {

    getUsersData: () => {
        return xhr.get({
            url: '/api/user/umUserCounts'
        })
    },

    getActiveCount: () => {
        return xhr.get({
            url: '/api/entities/companies/active/count'
        })
    },

    getInactiveEntitiesCount() {
        return xhr.get({
            url: '/api/entities/companies/non-active/count'
        })
    },

    getSubscription: () => {
        return xhr.get({
            url: '/api/customer/subscription'
        })
    },

    getEntitiesData: () => {
        return Promise.all([
            api.getActiveCount(),
            api.getInactiveEntitiesCount(),
            api.getSubscription()
        ]).then(responses => {
                return {
                    entitiesActive:   responses[0].body,
                    entitiesInactive: responses[1].body,
                    subscription:  responses[2].body.maximumNoOfThirdParties
                }})
    },

    getAlertsCount: (active) => {
        return xhr.get({
            url: `/api/alerts/count?sortBy=active&direction=desc&active=${active}`
        });
    },

    getAlertsData: () => {
        return Promise.all([
            api.getAlertsCount(true),
            api.getAlertsCount(false),
        ]).then(responses => {
            return {
                alertsActive:   responses[0].body,
                alertsInactive: responses[1].body
            }})
    }

};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/AccountUsage.api.js